import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route } from 'react-router';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import GetStarted from '../pages/get_started/get_started.component';
import Travel from '../pages/travel';
import Home from '../pages/home/home.component';
import Food from '../pages/food/food.component';
import Shopping from '../pages/shopping/shopping.component';
import TakeAction from '../pages/take_action/take_action.component';
import Missing from '../pages/missing/missing.component';
import { wrap, withT, withRouterAndHelpers } from '../../lib/wrappers';
import types from '../../types';
import RouteContainer from './RouteContainer';
import { routes, makePathConfigs } from '../../lib/routerHelper';

const getRouteComponent = (route) => {
  switch (route) {
    case routes.GET_STARTED:
      return GetStarted;
    case routes.TRAVEL:
      return Travel;
    case routes.HOME:
      return Home;
    case routes.FOOD:
      return Food;
    case routes.SHOPPING:
      return Shopping;
    case routes.TAKE_ACTION:
      return TakeAction;
    default:
      throw new Error(`Route not supported ${route}.`);
  }
};

let lastRouteIndex;
let lastTransitionClassName;

const Routes = ({ t, location, currentRouteIndex }) => {
  let transitionClassName = 'cc_page--left';
  if (currentRouteIndex > lastRouteIndex) {
    transitionClassName = 'cc_page--right';
  } else if (currentRouteIndex === lastRouteIndex) {
    transitionClassName = lastTransitionClassName;
  }
  lastRouteIndex = currentRouteIndex;
  lastTransitionClassName = transitionClassName;
  return (
    <RouteContainer locationKey={currentRouteIndex}>
      <TransitionGroup>
        <CSSTransition
          key={location.key}
          timeout={500}
          classNames={transitionClassName}
        >
          <Switch location={location}>
            {makePathConfigs(t).map(({ pathname, route }, _index) => (
              <Route key={route} path={pathname} component={getRouteComponent(route)} exact />
            ))}
            <Route component={Missing} />
          </Switch>
        </CSSTransition>
      </TransitionGroup>
    </RouteContainer>
  );
};

Routes.propTypes = {
  t: PropTypes.func.isRequired,
  location: types.RouterLocation.isRequired,
  currentRouteIndex: PropTypes.number.isRequired,
};

export default wrap(
  withT('routes'),
  withRouterAndHelpers,
  Routes,
);
